import { JSX } from 'react';
import { TimePicker } from '@progress/kendo-react-dateinputs';
import { Input, TextArea } from '@progress/kendo-react-inputs';

import AnswerFile from './answer-file';
import AnswerRadio from './answer-radio';
import AnswerImage from './answer-image';
import AnswerVideo from './answer-video';
import AnswerCheckbox from './answer-checkbox';
import { getTimePickerFormat } from '../../../../utils/date';
import { TaskContentForm } from '../../../../types/game-document/entities/task-content';

type AnswerType =
  | 'radio'
  | 'checkbox'
  | 'text'
  | 'file'
  | 'image'
  | 'video'
  | 'number'
  | 'textarea'
  | 'text'
  | 'date'
  | 'time'
  | 'none';

const Answer = ({ form }: { form: TaskContentForm }) => {
  const answerType = form.type as AnswerType;

  const renderAnswer = (): JSX.Element => {
    switch (answerType) {
      case 'file':
        return <AnswerFile />;
      case 'video':
        return <AnswerVideo />;
      case 'image':
        return <AnswerImage />;
      case 'radio':
        return <AnswerRadio answers={form.answers ?? []} />;
      case 'checkbox':
        return <AnswerCheckbox answers={form.answers ?? []} />;
      case 'text':
        return (
          <Input
            id={'answer-text'}
            placeholder={'Type your answer here'}
            className={'border-dark'}
          />
        );
      case 'number':
        return (
          <Input
            id={'answer-number'}
            type={'number'}
            onKeyDown={(e) => {
              const regex = /^[0-9.]$/;
              const value = e.currentTarget.value as string;
              const navigationKeys = [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'Tab'
              ];
              if (navigationKeys.includes(e.key)) {
                return;
              }

              if (e.key === '.' && value.includes('.')) {
                e.preventDefault();
                return;
              }

              if (!regex.test(e.key)) {
                e.preventDefault();
              }
            }}
            className={'border-dark'}
          />
        );
      case 'textarea':
        return (
          <TextArea
            id={'answer-textarea'}
            rows={20}
            placeholder={'Type your answer here'}
            className={'border-dark'}
          />
        );
      case 'time':
        return (
          <TimePicker
            id={'answer-time'}
            defaultValue={getTimePickerFormat(undefined)}
            className={'border-dark'}
          />
        );
      default:
        return <p id={'answer-none'}></p>;
    }
  };

  return (
    <div
      className={
        'd-flex justify-content-center h-100 overflow-y-auto overflow-x-hidden'
      }>
      <div
        className={`d-flex flex-column ${['text', 'number', 'time'].includes(answerType ?? '') ? 'short-answer' : 'long-answer'}`}>
        <div
          id={`answer-type-${answerType}`}
          className={`answer-container h-100 w-100`}>
          {renderAnswer()}
        </div>
      </div>
    </div>
  );
};

export default Answer;
